// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantProfileWidgetStageScreening-modulecontent__C9UoJ WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "RentalPortalApplicantProfileWidgetStageScreening-modulepoolHint__XX1gB";
export { _1 as "content", _2 as "poolHint" }
